// * Bootstrap libraries
import './_bootstrap';

// * Any other global site-wide JavaScript should be placed below.

(function($) {

    $(document).ready(function() {

        $('.block--project-organization-block .field--name-field-block-image .field__wrapper .field__item').photobox('a',{ time:0 });
        $('.block--reviews-block .field--name-field-block-image .field__wrapper .field__item').photobox('a',{ time:0 });
        $('.paragraph--type--custom-block .field--name-field-block-image .field__wrapper .field__item').photobox('a',{ time:0 });
        $('.node .field--name-field-projects-gallery .field__item').photobox('a',{ time:0 });

        $('.fancy-form').fancybox();

        $('.view-review .views-field-field-review-body').readmore({
            speed: 75,
            collapsedHeight: 75,
            moreLink: '<a href="#" class="rm_button_more">Читать полностью</a>',
            lessLink: '<a href="#" class="rm_button_less">Скрыть</a>'
        });

        // плавающая шапка
        $(window).scroll(function() {
            if ($(this).scrollTop() > 0){
                $('#header').addClass("glide");
            }
            else{
                $('#header').removeClass("glide");
            }
        });

        // add now year
        var currentYear = new Date().getFullYear();
        $(".block--copyright-box .copyrights_box").prepend("1998–"+currentYear+" ");

        // карусель projects на главной
        $('.block--projects-gallery-block .view-content').slick({
            dots: true,
            infinite: true,
            speed: 500,
            autoplay: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            adaptiveHeight: true,
            arrows: true,
            prevArrow: '<button class="slick-prev" aria-label="Previous" type="button"></button>',
            nextArrow: '<button class="slick-next" aria-label="Next" type="button"></button>',
        });

        // карусель docs на главной
        $('.block--project-organization-block .field--name-field-block-image .field__wrapper').slick({
            dots: true,
            infinite: true,
            speed: 500,
            autoplay: false,
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: true,
            prevArrow: '<button class="slick-prev" aria-label="Previous" type="button"></button>',
            nextArrow: '<button class="slick-next" aria-label="Next" type="button"></button>',
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 565,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ]
        });

        // карусель reviews на главной
        $('.block--reviews-block .field--name-field-block-image .field__wrapper').slick({
            dots: true,
            infinite: true,
            speed: 500,
            autoplay: false,
            slidesToShow: 6,
            slidesToScroll: 1,
            arrows: true,
            prevArrow: '<button class="slick-prev" aria-label="Previous" type="button"></button>',
            nextArrow: '<button class="slick-next" aria-label="Next" type="button"></button>',
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 5
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 4
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 565,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ]
        });

        const container = document.querySelector(".warning");
        if (document.cookie.indexOf("warning") != -1) {
            container.classList.remove("warning--active");
        }
        if (document.querySelector(".warning")) {
            const apply = container.querySelector(".warning__apply");
            apply.addEventListener("click", () => {
                container.classList.remove("warning--active");
                document.cookie = "warning=true; max-age=2592000; path=/";
            });
        };



        $('.nav_mobile_bg').click(function(){
            $('#nav_mobile').removeClass('show_menu');
            $('.btn_open').toggleClass('active_btn');
        });

        $('.navmobile_button .btn_open, .nav_mobile_button .btn_close').click(function() {
            $(this).toggleClass('active_btn');
            $('#nav_mobile').toggleClass('show_menu');
            $('body').toggleClass('mobile_menu_overflow');
        });

        $('.nav_mobile_bg').click(function(){
            $('#nav_mobile').removeClass('show_menu');
            $('.btn_open').toggleClass('active_btn');
            $('.btn_close').toggleClass('active_btn');
            $('body').toggleClass('mobile_menu_overflow');
        });

    });
})(jQuery);